export default __webpack_public_path__ + "static/media/tranbarsSurdeg.1204e474.jpg";